import React, { useMemo, useState, useEffect, useCallback, useRef } from "react";
import { Button } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import search from "../../assets/Vehicles/search.png";
import { Plus, ChevronLeft, ChevronRight } from "lucide-react";
import close from "../../assets/Vehicles/close_filter.png";
import fill_chevron_down from "../../assets/Vehicles/fill_chevron_down.png";
import customize from "../../assets/Vehicles/customize.png";
import down from "../../assets/Vehicles/chevron_down.png";

import { useReactTable, getCoreRowModel, getSortedRowModel, getFilteredRowModel, getPaginationRowModel, flexRender } from "@tanstack/react-table";

import { Columns } from "../Vehicles/Column";
import MOCK_DATA from "../Vehicles/MOCK_DATA.json";
import "../Vehicles/Vehicle_list/List.css";
import { useNavigate } from "react-router-dom";
import editIcon from "../../assets/svg/edit.svg";
import delIcon from "../../assets/svg/delete.svg";
import { getInspectionListApi } from "./inspection-api.js";
import DeleteModal from "../common/delete-modal.js";
import ReactPaginate from "react-paginate";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import lar from "../../assets/svg/lar.svg";
import rar from "../../assets/svg/rar.svg";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import DatePicker from "react-datepicker";
import { Calendar, Clock } from "lucide-react";
import "../../Util.css";
import { useGlobal } from "../../GlobalContext.js";

export const Inspection = () => {
  const { rolePermissionList, userType } = useGlobal();
  const isFirstRender = useRef(true);
  const columns = [
    {
      header: "Inspection Type",
      accessorKey: "type",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },

    {
      header: "Vehicle Number",
      accessorKey: "lic_no",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "Start Date",
      accessorKey: "start_date",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },

    {
      header: "Start Time",
      accessorKey: "start_time",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },

    {
      header: "Submitted Date",
      accessorKey: "submitted_date",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },

    {
      header: "Submitted Time",
      accessorKey: "submitted_time",
      cell: (info) => {
        console.log(info);
        return (
          <div
            className="hover-action-cell"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              minWidth: "150px",
            }}
          >
            <span>{info.getValue()} </span>
            {/*  <div className="click-actions">
                            <button className="icon-btn"
                              onClick={(e) => {
                                e.stopPropagation(); // prevent triggering row click
                              
                                navigate("/inspection/create", { state: {id:info.row.original.id} })
                              }}
                            >
                               <img src={editIcon} alt="edit" />
                            </button>
                            <button  className="icon-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                setDeleteId(info.row.original.id);
                              }}
                            >
                             <img src={delIcon} alt="delete" />
                            </button>
                          </div> */}
          </div>
        );
      },
    },
  ];
  const data = useMemo(() => MOCK_DATA, []);
  const navigate = useNavigate();

  // Global filter (search)
  const [globalFilter, setGlobalFilter] = useState("");
  const [sortByValue, setSortByValue] = useState({
    value: "created desc",
    label: "Created (Newest)",
  });
  const [sortByField, setSortByField] = useState("created");
  const [sortByDir, setSortByDir] = useState("desc");

  const [hoveredRow, setHoveredRow] = useState(null);

  const [startDate, setStartDate] = useState();
  const [submitDate, setSubmitDate] = useState();
  const [startTime, setStartTime] = useState(null);
  const [submitTime, setSubmitTime] = useState(null);

  const sortByList = [
    { value: "name asc", label: "Name (Asc)" },
    { value: "name desc", label: "Name (Desc)" },
    { value: "created asc", label: "Created (Oldest)" },
    { value: "created desc", label: "Created (Newest)" },
    { value: "updated asc", label: "Updated Date (Oldest)" },
    { value: "updated desc", label: "Updated Date (Newest)" },
  ];

  const [inspectionList, setInspectionList] = useState([]);
  const [listCount, setListCount] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    /* if (isFirstRender.current) {
    isFirstRender.current = false; // skip first run
    return;
  } */
    getInspectionList();
  }, [itemsPerPage, itemOffset, globalFilter, sortByValue, startDate, startTime, submitDate, submitTime]);
  const getInspectionList = async () => {
    try {
      /* &from_date=${fromCreatedDate}&to_date=${toCreatedDate}&status=${selectedStatus}&sort_field=${sortField}&sort_dir=${sortDir} */
      const response = await getInspectionListApi(
        `search=${globalFilter}&limit=${itemsPerPage}&skip=${itemOffset * itemsPerPage}&sort_field=${sortByField}&sort_dir=${sortByDir}&start_date=${startDate != null && startDate !== "" ? startDate.toLocaleDateString("en-CA") : ""}&start_time=${
          startTime != null && startTime !== ""
            ? startTime.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              })
            : ""
        }&submitted_date=${submitDate != null && submitDate !== "" ? submitDate.toLocaleDateString("en-CA") : ""}&submitted_time=${
          submitTime != null && submitTime !== ""
            ? submitTime.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              })
            : ""
        }`,
      );
      if (response.data.success === true) {
        setListCount(response.data.total_rec);
        setInspectionList(response.data.inspections);
        setPageCount(response.data.total_pgs);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const handlePageClick = useCallback((event) => {
    const newOffset = (event.selected * itemsPerPage) % inspectionList.length;
    console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
    setItemOffset(event.selected);
  }, []);

  const table = useReactTable({
    data: inspectionList ?? [],
    columns,
    state: {
      globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  const { pageIndex, pageSize } = table.getState().pagination;
  const pageOptions = table.getPageOptions();
  const handleRowClick = (rowData) => {
    navigate("/inspection/view", { state: rowData });
  };
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId != null && deleteId !== 0) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  const cancelDelete = () => {
    setDeleteId(null);
    setIsOpenDelete(false);
  };
  const onSuccessDelete = (response) => {
    setDeleteId(null);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    if (response.success === true) {
      setIsOpenDelete(false);
      getInspectionList();
    }
  };
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex((element) => element["name"] === menuName && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }

  return (
    <>
      {isOpenDelete && <DeleteModal deleteUrl={`inspection/delete/${deleteId}`} onSuccess={onSuccessDelete} onCancel={cancelDelete} />}
      <div className="bg-half-white">
        <div className=" rounded-4" style={{ background: "#FFFFFF", margin: "16px" }}>
          <div className="d-flex p-3 flex-wrap align-items-center justify-content-between">
            <div className="d-flex flex-column">
              <p className="bg-transparent fw-bold dark-purple border-0 fs-24 assigned-dropdowns m-0">Inspection</p>
              <p className="text-muted">{listCount} records</p>
            </div>
            <div className="d-flex flex-wrap gap-3">
              <div className="search-wrapper d-flex align-items-center gap-2 bg-white rounded-3 px-3 py-2">
                <img src={search} alt="search" />
                <input type="text" placeholder="Search" className="border-0 outline-0 rounded-3" value={globalFilter || ""} onChange={(e) => setGlobalFilter(e.target.value)} />
              </div>
              {checkPermission("Inspection History", "create_permission") && (
                <Button
                  className="dark-purple-btn border-0 d-flex gap-1 px-3 rounded-3 text-white"
                  onClick={() => {
                    navigate("/inspection/create");
                  }}
                >
                  <Plus />
                  Add new
                </Button>
              )}
            </div>
          </div>

          {/* Filters */}
          <div className="d-flex flex-wrap align-items-center justify-content-between p-3 gap-2">
            <div className="d-flex flex-wrap align-items-center gap-3">
              <p className="m-0 text-filter-grey fw-semibold">Filter :</p>
              <Dropdown data-tooltip-id="sort-tooltip" data-tooltip-content="Sort by">
                <Dropdown.Toggle id="dropdown-basic" className="bg-white search-border text-purple assigned-dropdown rounded-4 px-4 d-flex align-items-center gap-2">
                  {sortByValue.label}
                  <img src={fill_chevron_down} alt="chev down" />
                  <img src={close} alt="x" />
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                  {sortByList.map((item) => (
                    <Dropdown.Item
                      onClick={() => {
                        const arr = item.value.split(" ");
                        if (arr.length > 1) {
                          setSortByField(arr[0]);
                          setSortByDir(arr[1]);
                        }
                        setSortByValue(item);
                      }}
                    >
                      {item.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
                <Tooltip id="sort-tooltip" place="top" />
              </Dropdown>

              <div className="w-15 w-md-25 w-lg-18 d-flex align-items-center bg-white text-purple  search-border rounded-4" style={{ maxWidth: "180px" }} data-tooltip-id="startdate-tooltip" data-tooltip-content="Start Date">
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  dateFormat="dd-mm-yyyy"
                  customInput={
                    <button style={{ color: "#8790A1" }} className="border-0 form-control vehicle-form-input bg-white rounded-4 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                      {startDate ? startDate.toLocaleDateString("en-GB").replace(/\//g, "-") : <span style={{ color: "#8790A1" }}>dd-mm-yyyy</span>}
                      <Calendar size={16} />
                    </button>
                  }
                />
                <Tooltip id="startdate-tooltip" place="top" />
                {startDate != null && <img onClick={() => setStartDate(null)} src={close} alt="x" style={{ height: "30px" }} />}
              </div>

              <div className="w-15 w-md-25 w-lg-18 d-flex align-items-center bg-white text-purple  search-border rounded-4" style={{ maxWidth: "180px" }} data-tooltip-id="starttime-tooltip" data-tooltip-content="Start Time">
                <DatePicker
                  selected={startTime}
                  onChange={(time) => setStartTime(time)}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Time"
                  dateFormat="h:mm aa"
                  customInput={
                    <button style={{ color: "#8790A1" }} className="btn-border-grey form-control vehicle-form-input bg-white  border-0 rounded-4  px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                      {startTime ? (
                        startTime.toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                      ) : (
                        <span style={{ color: "#8790A1" }}>hh:mm</span>
                      )}
                      <Clock size={16} />
                    </button>
                  }
                />
                <Tooltip id="starttime-tooltip" place="top" />
                {startTime != null && <img onClick={() => setStartTime(null)} src={close} alt="x" style={{ height: "30px" }} />}
              </div>

              <div className="w-15 w-md-25 w-lg-18 d-flex align-items-center bg-white text-purple search-border rounded-4" style={{ maxWidth: "180px" }} data-tooltip-id="submit-date-tooltip" data-tooltip-content="Submit Date">
                <DatePicker
                  selected={submitDate}
                  onChange={(date) => setSubmitDate(date)}
                  dateFormat="dd-mm-yyyy"
                  customInput={
                    <button style={{ color: "#8790A1" }} className="border-0 form-control vehicle-form-input bg-white rounded-4 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                      {submitDate ? submitDate.toLocaleDateString("en-GB").replace(/\//g, "-") : <span style={{ color: "#8790A1" }}>dd-mm-yyyy</span>}
                      <Calendar size={16} />
                    </button>
                  }
                />
                <Tooltip id="submit-date-tooltip" place="top" />
                {submitDate != null && <img onClick={() => setSubmitDate(null)} src={close} alt="x" style={{ height: "30px" }} />}
              </div>

              <div className="w-15 w-md-25 w-lg-18 d-flex align-items-center bg-white text-purple search-border rounded-4" style={{ maxWidth: "180px" }} data-tooltip-id="submit-time-tooltip" data-tooltip-content="Submit Time">
                <DatePicker
                  selected={submitTime}
                  onChange={(time) => setSubmitTime(time)}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Time"
                  dateFormat="h:mm aa"
                  customInput={
                    <button style={{ color: "#8790A1" }} className="btn-border-grey form-control vehicle-form-input bg-white border-0 rounded-4 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                      {submitTime ? (
                        submitTime.toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                      ) : (
                        <span style={{ color: "#8790A1" }}>hh:mm</span>
                      )}
                      <Clock size={16} />
                    </button>
                  }
                />
                <Tooltip id="submit-time-tooltip" place="top" />
                {submitTime != null && <img onClick={() => setSubmitTime(null)} src={close} alt="x" style={{ height: "30px" }} />}
              </div>
            </div>
            {/*  <Button className="bg-white border-purple rounded-pill text-dark-purple px-3">
              <img src={customize} alt="cuz" /> Customize table
            </Button> */}
          </div>

          {/* Table */}
          <div className="p-3">
            <div className="table-wrapper overflow-x-auto">
              <table>
                <thead>
                  {table.getHeaderGroups().map((headerGroup) => (
                    <tr key={headerGroup.id}>
                      {headerGroup.headers.map((header) => (
                        <th key={header.id} className="px-3 py-2" onClick={header.column.getToggleSortingHandler()}>
                          {flexRender(header.column.columnDef.header, header.getContext())}
                          {header.column.getIsSorted() === "asc" && " asc"}
                          {header.column.getIsSorted() === "desc" && " des"}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody>
                  {table.getRowModel().rows.map((row, index) => (
                    <tr
                      key={"row" + index + row.id}
                      style={{
                        position: "relative",
                        backgroundColor: hoveredRow === index ? "#F9F2FF" : "#ffffff",
                        cursor: "pointer",
                        transition: "border-color 0.3s",
                        borderLeft: hoveredRow === index ? "3px solid #471070" : "3px solid #E5E5E5",
                      }}
                      onClick={() => handleRowClick(row.original)}
                      onMouseEnter={() => setHoveredRow(index)}
                      onMouseLeave={() => setHoveredRow(null)}
                    >
                      {row.getVisibleCells().map((cell) => (
                        <td key={cell.id} className="px-3 py-2">
                          {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </td>
                      ))}
                      {hoveredRow === index && (
                        <td
                          style={{
                            position: "absolute",
                            right: "10px",
                            display: "flex",
                            gap: "8px",
                            border: "none",
                          }}
                          className="px-3 py-2"
                        >
                          {checkPermission("Inspection History", "edit_permission") && (
                            <button
                              className="icon-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate("/inspection/create", {
                                  state: { id: row.original.id },
                                });
                              }}
                            >
                              <img src={editIcon} alt="edit" />
                            </button>
                          )}
                          {checkPermission("Inspection History", "delete_permission") && (
                            <button
                              className="icon-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                setDeleteId(row.original.id);
                              }}
                            >
                              <img src={delIcon} alt="delete" />
                            </button>
                          )}
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <Dropdown>
                <span className="pagination-color">Records per page: &nbsp;</span>
                <Dropdown.Toggle id="dropdown-basic" className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0">
                  <span className="bg-white no-of-rows rounded-3 px-2 py-2">
                    {itemsPerPage} <img src={down} alt="" />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="my-2" style={{ minWidth: "unset", width: "30%" }}>
                  {[10, 25, 50, 75, 100].map((size) => (
                    <Dropdown.Item
                      key={size}
                      onClick={() => {
                        table.setPageSize(size);
                        setItemsPerPage(size);
                        setItemOffset(0);
                      }}
                      active={itemsPerPage === size}
                      className="text-center"
                    >
                      {size}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="d-flex align-items-center gap-2">
                <ReactPaginate previousLabel={<img src={lar} className="ar3" alt="previous" />} nextLabel={<img src={rar} className="ar3" alt="next" />} breakLabel={"..."} pageCount={pageCount + 1} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination"} activeClassName={"active"} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
